type Props = {
  status: TournamentStatus;
  won?: boolean;
};

const getTournamentColor = ({ status = "past", won }: Props) => {
  switch (status) {
    case "current":
      return "var(--positive)";
    case "future":
      return "var(--primary)";
    case "past":
      return won ? "var(--warning)" : "var(--muted-foreground)";
    default:
      return "var(--muted-foreground)";
  }
};

export default getTournamentColor;
